<div class="modal-header">
  <h4 class="modal-title">Error</h4>
</div>
<div class="modal-body">
  A Request you are trying to action has already been actioned. Please refresh
  the Approvals panel.
</div>
<div class="modal-footer">
  <div>
    <button nf-button="save" (click)="activeModal.close(true)">Refresh</button>
  </div>
</div>
